import { SearchOutlined } from '@mui/icons-material';
import { Box } from '@mui/material';

import { style } from './styles';

export default function SearchInput ({ onTextChange }: { onTextChange: (text: string) => void; }) {
  return (
    <Box sx={style}>
      <input type="text" onChange={e => { onTextChange(e.target.value); }} />
      <SearchOutlined color="primary" />
    </Box>
  );
}
